import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Home from './components/Home';
import CreateRoute from './components/CreateRoute';
import ViewRoutes from './components/ViewRoutes';
import ViewData from './components/ViewData'; // Added import

function App() {
  return (
    <Router>
      <nav aria-label="Primary navigation">
        <ul>
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/create-route">Create Route</Link>
          </li>
          <li>
            <Link to="/view-routes">View Routes</Link>
          </li>
          <li>
            <Link to="/view-data">View Data</Link>
          </li>
        </ul>
      </nav>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/create-route" element={<CreateRoute />} />
        <Route path="/view-routes" element={<ViewRoutes />} />
        <Route path="/view-data" element={<ViewData />} /> {/* Added route */}
      </Routes>
    </Router>
  );
}

export default App;